export enum OnboardingType {
  CreateFirstArticle = 'CreateFirstArticle',
  ScheduleMessage = 'ScheduleMessage',
  SpaceDemo = 'SpaceDemo',
  SpaceFriends = 'SpaceFriends',
  SpaceLink = 'SpaceLink',
}
